<script setup>
import { reactiveOmit } from '@vueuse/core';
import { ChevronLeft } from '@lucide/vue';
import { DatePickerPrev, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/Components/ui/button';

const props = defineProps({
    prevPage: { type: Function, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerPrev
        :class="cn(buttonVariants({ variant: 'default' }), 'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100', props.class)"
        v-bind="forwardedProps"
    >
        <slot>
            <ChevronLeft class="h-4 w-4" />
        </slot>
    </DatePickerPrev>
</template>
